module.exports = __webpack_public_path__ + "img/cooperate_37.c51bc4d8.png";